/**
 * Portfolio data hook — reads from shared PortfolioDataContext.
 *
 * All pages that call usePortfolioData() share the same cached data.
 * The orgId parameter is accepted for backward compatibility but ignored;
 * the context already binds to the current org from AuthContext.
 */
import { useContext } from 'react'
import { PortfolioDataContext } from './PortfolioDataContext'

// eslint-disable-next-line no-unused-vars
export function usePortfolioData(_orgId) {
  const ctx = useContext(PortfolioDataContext)
  if (!ctx) {
    throw new Error('usePortfolioData must be used within PortfolioDataProvider')
  }
  return ctx
}
